import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import styles from "./Slider.module.scss";
import Layout from "../../layouts/Layout/Layout";
import { Button } from "../../elements";
import Home from '../../../assets/home_logo.png'
import Home_bg from '../../../assets/background_image.jpeg';



export default ({ data = [] }) => {
  let sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  // useEffect(()=>{
  //   var first = document.getElementById("first");
  //   var second = document.getElementById("second");
  //   var logo = document.getElementById("home_logo");


  //   console.log(logo.style)
  //   window.addEventListener('scroll',()=>{
  //     let value = window.scrollY;

  //     first.style.right = 0.25*value +'px';
  //     second.style.left = 0.25*value +'px';

  //   })
  // })


  const slideList = data.map((item, index) => (
    <article key={index}>
      <Layout
        style={{
          background: 'url(' + item.image + ') center/cover',
        }}
        col='1'
        mode='dark'
      >
        <div className={styles.slide}>
          <div className={styles.intro}>
            <img id="home_logo" src={Home}></img>
          </div>
        </div>
      </Layout>
    </article>
  ));

  return (
    // <Slider ref={(slider) => (sliderRef = slider)} {...settings}>
    //   {slideList}
    // </Slider>
    <Layout
      style={{
        background: "url(" + Home_bg + ") center/cover",
        backgroundAttachment: "fixed"
      }}
      col="1"
      mode="dark"
    >
      <div className={styles.slide}>
        <i
          className={"las la-long-arrow-alt-left"}
          style={{ visibility: "hidden" }}

        />
        <div className={styles.intro}>
          {/* <div className="textbox">
                {/* <h1 id="first">E</h1>
                <h1 id="second">CELL</h1>  
              </div> */}

          <div className="textbox">
            {/* <h1 id="first">E</h1>
                <h1 id="second">CELL</h1>  */}
            {/* <h2 id="first">Foster</h2> */}
            <img id="home_logo" src={Home} className={styles.logo} />
            {/* <h2 id="second">the Spark</h2> */}
          </div>


        </div>
        <i
          className={"las la-long-arrow-alt-right"}
          style={{ visibility: "hidden" }}

        />
      </div>
    </Layout>
  );
};
